export function formatListQueryOutput(data: any): any[] {
  return data ? (data[Object.keys(data)[0]]?.list || []) : [];
}

export function formatTotalQueryOutput(data: any): number {
  return data ? (data[Object.keys(data)[0]]?.total || 0) : 0;
}
